export const ugovor_o_kompenzaciji = {
    templateId: 54,
    category: 2,
    templateTitle: "Ugovor o kompenzaciji (prijeboju)",
    templateDescription: `Ugovornom kompenzacijom strane dobrovoljno uređuju prava i obveze koje proizlaze iz međusobnih tražbina. Za razliku od kompenzacije temeljem izjave, ugovornom kompenzacijom mogu se kompenzirati tražbine koje su nedospjele, zastarjele i sl.. Za točniji odabir načina reguliranja međusobnih odnosa predlažemo da koristite <a target="_blank" href="http://solucio-debit.com">SOLUCIO DEBIT app</a>.`,
    description: `
      <h5>OPIS I SVRHA DOKUMENTA</h5>
      <p>Do prijeboja može doći voljom jedne (Izjava o kompenzaciji) ili obje stranke, po sili zakona ili na osnovu sudske odluke pa s obzirom na to razlikujemo: jednostranu, ugovornu, zakonsku i sudsku kompenzaciju.</p>
      <p>Ugovornom kompenzacijom strane dobrovoljno uređuju prava i obveze koje proizlaze iz međusobnih tražbina. </p>
      <p>U pogledu ugovorne kompenzacije nema ograničenja koja postoje kod jednostrane kompenzacije te je ugovornu kompenzaciju moguće obaviti i za:</p>
      <ul>
      <li> tražbine koje nisu istorodne (novac, roba i sl.),</li>
      <li> nedospjele tražbine, </li>
      <li> zastarjele tražbine. (naplaćivanja),</li>
      </ul>
      <p>Osim toga, učinci ugovorne kompenzacije, ne nastupaju od trenutka ispunjenja pretpostavki kompenzacije, kao kod  kompenzacije na temelju izjave, nego od trenutka koji ugovorne strane odrede.</p>
      <p>Ukoliko ugovorne strane nisu odredile trenutak kompenzacije, kompenzacija proizvodi učinke od trenutka sklapanja ugovora o kompenzaciji.</p>
      <p><strong>NAPOMENA: Ovršenik (dužnik) kao poslovni subjekt ne smije  (prema Zakonu o provedbi ovrhe na novčanim sredstvima) sklapati ugovore radi obračunskog plaćanja ako u Jedinstvenom registru računa ima oznaku blokade računa, odnosno zabranu raspolaganja oročenim novčanim sredstvima, ako tim obračunskim plaćanjem kao vjerovnik tražbine onemogućuje ili izbjegava primitak ispunjenja obveze u novcu. Novčana kazna u slučaju kršenja navedenog može biti do 500.000,00 kn. </strong></p>
   
  <p><strong> Osim toga, sukladno Zakonu o obveznim odnosima takav ugovor je ništetan (ne proizvodi nikakve pravne učinke) jer je protivan prisilnim propisima (Zakon o provedbi ovrhe na novčanim sredstvima). <p></strong>
  <p><strong>Vjerovnik koji je znao za postojeću blokadu računa svojeg dužnika može biti kazneno odgovoran (za kazneno djelo prijevare u
  gospodarskom poslovanju te pomaganju u pogodovanju vjerovnika) ukoliko unatoč izričitoj zabrani ipak sklopi
  ugovor o obračunskom plaćanju u cilju naplate svojeg potraživanja prije drugih
  vjerovnika, koji prema redoslijedu naplate s blokiranog računa dužnika imaju prednost
  pri namirenju, a u tom slučaju i odgovara trećima za nastalu štetu.   <p></strong>
  <p>Osim što ne smije svoje obveze plaćati gotovim novcem, dužnik (poslovni subjekt) kojemu je blokiran račun ne smije plaćati preko institucije za platni promet niti preko ostalih pružatelja platnih usluga u Republici Hrvatskoj, kao niti plaćati ili primati plaćanja preko računa otvorenog kod pružatelja platnih usluga u inozemstvu, a ne smije niti preusmjeravati novčane i financijske tijekove na drugu osobu niti primati uplate i isplaćivati novčana sredstva na račune drugih osoba.</p> 
      <h5>PRAVNA OSNOVA</h5>
      <p>Zakon o obveznim odnosima.</p>
    `,
  
    sides: [
      {
          signature: '',
          inputs: [{
              type: "input",
              required: true,
              placeholder: 'Posl. subjekt / Ime i prezime',        
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              placeholder: "Zastupa (za pr. osobe)",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija (za pr. osobe)",
              inSignature: true,
            }],
          delimiter: `i`
      },
      {
          signature: '',
          inputs: [{
              type: "input",
              required: true,
              placeholder: 'Posl. subjekt / Ime i prezime',        
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              mandatory: false,
              editable: true,
              placeholder: "Zastupa (za pr. osobe)",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija (za pr. osobe)",
              inSignature: true,
            }],
            suffix: ","
      }
  ],
  
  
    headline: "zaključuju sljedeći",
    title: "UGOVOR O KOMPENZACIJI (PRIJEBOJU)",
  
    articles: [
  
            {
              title: "PREDMET UGOVORA",
              mandatory: true,
              statements: [
              
                {
                  type: "input",
                  editable: false,
                  mandatory: true,
                  parts: [
                
                    {type: "text", content: "Ovim Ugovorom vrši se prebijanje uzajamnih tražbina između ugovornih strana (dalje: kompenzacija), na način određen u nastavku."},
                    {type: "text", newline:"true", content: "\r\nUgovorne strane suglasno utvrđuju da imaju sljedeće međusobne tražbine:\r\n"},
                    { type: "text", content: "", newline:"true",},
                    { type: "input", value: "", help: "Unesite naziv prve ugovorne strane.", required: true },
                    { type: "text", content: "ima tražbinu prema"},
                    { type: "input", value: "", help: "Unesite naziv druge ugovorne strane.", required: true },
                    { type: "text", content: "u iznosu od"},
                    { type: "input", value: "", help: "Unesite ukupan svih tražbina prema drugoj ugovornoj strani, iznos tražbine i valutu.", required: true },
                    { type: "text", content: ","},
                    { type: "text", newline:"true", content: "\r\na"},
                    { type: "input", value: "", help: "Unesite naziv druge ugovorne strane.", required: true },
                    { type: "text", content: "ima tražbinu prema"},
                    { type: "input", value: "", help: "Unesite naziv prve ugovorne strane.", required: true },
                    { type: "text", content: "u iznosu od"},
                    { type: "input", value: "", help: "Unesite ukupan svih tražbina prema drugoj ugovornoj strani,  iznos tražbine i valutu.", required: true},
                    {type: "text", newline:"true", content: "\r\nUgovorne strane suglasno izjavljuju da su prethodno navedeni iznosi tražbina navedeni isključivo u svrhu provedbe ovog Ugovora te da međusobne tražbine eventualno mogu biti i veće, stoga se odriču pozivati da iznos tražbina navedenih u ovom Ugovoru predstavlja cjelokupni iznos međusobnih tražbina.`"},

                  ],
                  }
                ]
              }, 
        {
          title: "OPSEG KOMPENZACIJE",
          mandatory: true,
          statements: [
            {
              type: "choice",
              mandatory: true,
              editable: false,
              choices: [
                {
                  parts: [
                    { type: "text", content: "S obzirom da su međusobne tražbine ugovornih strana istog iznosa (iste vrijednosti), ovim Ugovorom se u cijelosti kompenziraju prethodno navedene međusobne tražbine ugovornih strana te se iste u cijelosti gase." },
                  ]
                },
                {
                  parts: [
                    { type: "text", content: "S obzirom da su međusobne tražbine ugovornih strana različitog iznosa (različite vrijednosti), ovim Ugovorom se kompenziraju međusobne tražbine na način da se tražbina veće vrijednosti umanjuje za visinu tražbine manje vrijednosti, čime se u cijelosti gasi tražbina manje vrijednosti te nakon provedene kompenzacije preostaje dio tražbine veće vrijednosti koji prelazi iznos tražbine manje vrijednosti (kompenzirani iznos)." },
                  ]
                },
                {
                  parts: [
                    { type: "text", content: "Bez obzira na iznose međusobnih tražbina ugovornih strana koji su navedeni u ovom Ugovoru, ugovorne strane kompenziraju međusobne tražbine u iznosu od" },
                    { type: "input", value: "", required: true, help: "Ovdje upisujete iznos međusobnih tražbina koje želite kompenzirati." },
                    { type: "text", content: "(kompenzirani iznos) te se međusobne tražbine ugovornih strana u kompenziranom iznosu u cijelosti gase." },
                  ]  
                }],
              value: "",
            }
          ]
        },
        {
      title: "IZJAVA O KOMPENZACIJI",
      mandatory: true,
      statements: [
      {
      type: "text",
      mandatory: true,
      editable: false,
      content: "Ugovorne strane suglasno utvrđuju da nema zakonskih smetnji za kompenzaciju, stoga ovim Ugovorom izjavljuju da međusobno kompenziraju međusobne tražbine na način određen ovim Ugovorom te se međusobne tražbine gase u opsegu koji je određen ovim Ugovorom (dalje: Izjava o kompenzaciji).",
      },
      {
        type: "text",
        mandatory: true,
        editable: false,
        content: "Sklapanjem ovog Ugovora, smatra se da je dana Izjava o kompenzaciji koja predstavlja knjigovodstvenu ispravu na osnovu koje se provodi knjiženje kompenzacije međusobnih tražbina u poslovnim knjigama ugovornih strana.",
        },
      ]
      },
      {
        title: "NEMOGUĆNOST KOMPENZACIJE",
        mandatory: false,
        statements: [
        {
        type: "text",
        mandatory: true,
        editable: true,
        content: "Ako je nekoj od ugovornih strana u vrijeme zaključenja ovog Ugovora bilo zabranjeno sklapanje istoga, smatrati će se da ovaj Ugovor nije ni sklopljen. \r\nIznimno od navedenog u prethodnom stavku ovog članka, ako je zabrana prijeboja (kompenzacije) otpala nakon sklapanja ovog Ugovora, a prije saznanja druge ugovorne strane o razlozima zabrane,  odredba prethodnog stavka ovog članka neće se primjenjivati.",
        },
        ]
        },
      {
        title: "MJERODAVNO PRAVO",
        mandatory: false,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Ugovorne strane suglasno utvrđuju da će se na sve odnose koji nisu riješeni ovim Ugovorom primjenjivati odredbe važećih propisa Republike Hrvatske, a primarno odredbe Zakona o obveznim odnosima."
          }
        ]
      },
      {
        title: "NADLEŽNOST",
        mandatory: false,
        statements: [
          {
            type: "choice",
            mandatory: true,
            editable: false,
            choices: [
              {
                parts: [
                  { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu" },
                  { type: "input", value: "", help: "Upisati naziv ugovorne strane prema čijem sjedište će se određivati nadležnost suda.", required: true },
                ]
              },
              {
                parts: [
                  { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u " },
                  { type: "input", value: "", help: "Upišite mjesno nadležni sud. Npr. sudom u Zagrebu; sudom u Splitu i sl..", required: true },
                ]
              }
            ],
          }
        ]
      },
      {
        title: "PRIMJENA UGOVORA",
        mandatory: false,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Ugovor se primjenjuje od trenutka potpisa ugovornih strana."
          }
        ]
      },
      {
        title: 'PRIMJERCI UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                value: '',
            }],
      },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/54_ugovor_o_kompenzaciji.ts